import React from 'react';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import PropTypes from 'prop-types';
import Label from 'oxyrion-ui/lib/Label/Label';
import Loader from 'oxyrion-ui/lib/Loader';
import Select from 'oxyrion-ui/lib/Select';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import Icon from 'oxyrion-ui/lib/Icon';
import { connect, actions } from '../../../../Store';
import Gallery from '../../../ProductCatalog/Components/Gallery';
import PopUpWrapper from '../../../../Components/PopUpWrapper';
import AlertPopup from '../../../../Components/AlertPopup';
import InfoWithTooltip from '../../../../Components/InfoWithTooltip';
import {
  __,
  formatPrice,
  getIdFromProps,
  formatColorToRGB,
} from '../../../../Utils';

import { normalizeParams } from '../../../../Utils/CatalogProductParamsNormalizer';
import {
  catalogDescTranslate,
  normalizeVariants,
} from '../../../ProductCatalog/CatalogUtils';
import {
  AnimatedFormMessageWrapper,
  LoaderWrapper,
} from '../../../../Components/ReusableComponents';
import SearchableSelect from '../../../../Components/SearchableSelect';
import ErrorMessage from '../../../../Components/ErrorMessage';
import Toning from '../../../Toning';
import AddToCartWidget from '../../../../Components/AddToCartWidget';
import CatalogCheckbox from '../../../ProductCatalog/Components/CatalogCheckbox';
import Description from './Description';
import Variants from '../../../ProductCatalog/Components/Variants';
import Documentation from '../../../ProductCatalog/Components/Documentation';
import Inspirations from './Inspirations';
import PaintSystems from './PaintSystems';
import References from './References';
import Videos from './Videos';
import './react-tabs.css';
import API2 from '../../../../API2';

const TextureWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: ${rem(150)};
  background: ${props => props.color};
  background-image: ${props => `url(${props.backgroundImage})`};
  background-size: cover; /* Adjust as needed, e.g., 'contain', 'auto', etc. */
  background-repeat: no-repeat;
  background-position: center center;
  color: ${props => props.textColor};
  text-shadow: ${rem(1)} ${rem(2)} ${rem(1)} ${props => props.shadowColor};
  border-radius: ${rem(4)} ${rem(8)} ${rem(4)} ${rem(8)};
  margin: ${rem(4)};
  padding: ${rem(4)} ${rem(8)} ${rem(4)} ${rem(8)};
  cursor: default;
  text-transform: capitalize;
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  font-weight: bold;
`;

const MainWrapper = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  background: #fcfcfc;
  justify-content: center;
  ${({ theme }) => theme.media.l`
  flex-direction:row;
`};
`;

const InsideWrapper = styled.div`
  max-width: ${rem(1500)};
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  padding: ${rem(4)};
`;

const SaleLabel = styled.div`
  background: red;
  color: white;
  position: absolute;
  right: 0px;
  top: 0px;
  border-radius: 11px;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`;

// const SaleNote = styled.div`
//   background: red;
//   position: absolute;
//   right: 0px;
//   top: 0px;
//   border-radius: 11px;
//   width: 20px;
//   height: 20px;
//   justify-content: center;
//   align-items: center;
//   display: flex;
//   cursor: pointer;
// `;

const ToningWrapper = styled.div`
  text-align: start;
  margin: 0;
  min-height: ${props => props.height && rem(props.height)};
`;

const VariantsWrapper = styled.div``;

const ToningButtonWrapper = styled.div`
  display: flex;
  color: #70af00;
  height: ${rem(15)};
  margin-left: ${rem(8)};
  background: white;
  padding: 9px;
  border-radius: 2px;
  border: 1px solid #70af00;
  cursor: pointer;
  font-size: ${rem(14)};
  &:hover {
    text-decoration: underline;
  }
  justify-content: center;
  align-items: center;
`;

const GalleryWrapper = styled.div`
  margin-right: ${rem(30)};
  display: flex;
  flex-direction: column-reverse;
  ${({ theme }) => theme.media.m`
flex-direction:column;
`};
`;

const BaseInfoWrapper = styled.div`
  width: 100%;
`;

const TopPart = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  width: 100%;
  ${({ theme }) => theme.media.l`
flex-direction: row;
`};
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1500px) {
    flex-direction: row;
  }
`;

const HalfInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Space = styled.div`
  width: ${rem(16)};
  height: ${rem(16)};
`;

const ProductsWrapper = styled.div`
  background: #e8f7ce;
`;

const ProductCell = styled.div`
  height: ${rem(42)};
  width: ${rem(150)};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${rem(4)};
  font-size: ${rem(12)};
  font-weight: bold;
  position: relative;
`;

const ProductCellHeader = styled(ProductCell)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${rem(64)};
  font-size: ${rem(12)};
`;

const ProductCellIcon = styled(ProductCell)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProductRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #70af00;
`;

const ProductCellHeaderDPH = styled(ProductCellHeader)`
  display: flex;
  flex-direction: column;
`;

const CustomLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: ${rem(100)};
`;

const CheckboxWrapper = styled.div`
  margin: ${rem(16)};
  display: flex;
`;

const UnderLabeL = styled.div`
  font-size: ${rem(12)};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  font-size: ${rem(14)};
`;

const Title = styled.div`
  font-size: ${rem(26)};
  font-weight: 700;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const ShortDesc = styled.div`
  font-size: ${rem(14)};
  max-width: ${rem(500)};
  font-weight: 200;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const Line = styled.div`
  height: ${rem(1)};
  width: 100%;
  margin-bottom: ${rem(15)};
  background: #e8f7ce;
`;

const Text = styled.div`
  font-size: ${rem(13)};
`;

const StyledLabel = styled(Label)`
  width: ${rem(60)};
`;

const ColorCodeInput = styled(SearchableSelect)`
  width: ${rem(220)};
  height: ${rem(40)};
  margin-left: ${rem(5)};
  height: ${rem(26)};
  border: ${rem(1)} solid #707070;
  border-radius: ${rem(3)};
  padding-left: ${rem(10)};
  outline: 0;
  font-size: ${rem(18)};

  ::placeholder {
    color: #f0f0f0;
    opacity: 1;
  }
`;

const ColorHolder = styled.div`
  width: 100%;
  @media (min-width: 1500px) {
    width: ${rem(300)};
  }
  background: ${props => props.color};
  height: ${rem(72)};
  border: ${rem(1)} solid #e2e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const ColorShadeCloser = styled.div`
  width: ${rem(20)};
  height: ${rem(20)};
  position: absolute;
  right: ${rem(-10)};
  top: ${rem(-10)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: red;
  border: 1px solid #e2e0e0;
  border-radius: ${rem(12)};
  cursor: pointer;
`;

const AddToCardWrapper = styled.div`
  height: ${rem(32)};
  width: ${rem(32)};
  border: 1px solid #70af00;
  border-radius: ${rem(2)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  cursor: pointer;
`;

const SelectWrapper = styled.div`
  width: ${rem(250)};
  margin-left: ${rem(10)};
`;

const StyledSelect = styled(Select)`
  width: ${rem(84)};
  height: ${rem(32)};
  margin-left: ${rem(8)};
`;

const ProductRowsWrapper = styled.div`
  max-height: ${rem(500)};
  overflow: auto;
`;

const TooltipWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${rem(12)};
  width: ${rem(24)};
`;

// const TooltipWrapperPlaceholder = styled.div`
//   width: ${rem(24)};
//   margin-left: ${rem(12)};
//   height: 1px;
// `;

const baseURL = 'https://api-v2.oxyrion.com/v1';

export const getRGBColorByBackground = color => {
  if (!color) {
    return '#363740';
  }

  return (color.r || color.R) * 0.299 +
    (color.g || color.G) * 0.587 +
    (color.b || color.B) * 0.114 >
    160
    ? '#363740'
    : '#ffffff';
};

export const getRGBShadeByBackground = color => {
  if (!color) {
    return rgba(255, 255, 255, 0.34);
  }

  return (color.r || color.R) * 0.299 +
    (color.g || color.G) * 0.587 +
    (color.b || color.B) * 0.114 >
    160
    ? rgba(176, 176, 176, 0.4)
    : rgba(0, 0, 0, 0.16);
};

class CatalogProductDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: 'main',
      selectedColorCode: '',
      selectedVariantIndex: -1,
      showColorCards: false,
      productLoading: true,
      variantsLoading: true,
      product: {},
      variants: [],
      variantsBases: [],
      showPriceWithHardener: false,
      params: [],
      inspirations: [],
      paintSystems: [],
      references: [],
      videos: [],
      basesSettings: [],
      defaultVariants: [],
      typesForTinting: [],
      paramsHeaders: [],
    };
  }

  async componentDidMount() {
    this.fetchData(getIdFromProps(this.props));
    actions.setActiveMenuItem('44');
  }

  async fetchData(id) {
    const promises = [
      API2.getB2BCatalogProductAction(id),
      API2.getB2BCatalogProductDocumentationAction(id),
      API2.getB2BCatalogProductInspirationsAction(id),
      API2.getB2BCatalogProductReferencesAction(id),
      API2.getB2BCatalogProductPaintSystemsAction(id),
      API2.getB2BMultimediaAction({
        type: 'video',
        productId: id,
      }),
      API2.getB2BTintingTypesAction(),
    ];

    try {
      const results = await Promise.all(promises);
      const productResult = results[0];
      const documentationResult = results[1];
      const inspirationsResult = results[2];
      const referencesResult = results[3];
      const paintSystemsResult = results[4];
      const videosResult = results[5];
      const typesForTinting = results[6].types || [];

      const defaultBase = productResult.bases_settings.find(b => b.is_default);

      const selectedBase =
        (productResult.baseTypes &&
          productResult.baseTypes.find(
            b => defaultBase && b === defaultBase.name,
          )) ||
        productResult.baseTypes[0];

      productResult.hasFinisedShade =
        productResult.variants &&
        productResult.variants.filter(v => v.finished_shade).length > 0;

      const normalizedVariants = this.normalizeVariants(
        productResult.variants || [],
        id,
      );

      const paramsHeaders = [];

      normalizedVariants.forEach(n =>
        n.normalizedParams.forEach(np => {
          if (!paramsHeaders.find(ph => ph.label === np.label)) {
            paramsHeaders.push(np);
          }
        }),
      );

      this.setState({
        paramsHeaders,
        product: productResult,
        inspirations: this.normalizeInspiration(
          inspirationsResult.references || [],
          id,
        ),
        references: this.normalizeReferences(
          referencesResult.references || [],
          id,
        ),
        typesForTinting,
        paintSystems: paintSystemsResult.paintSystems || [],
        variants: normalizedVariants,
        defaultVariants: normalizedVariants,
        allBases: productResult.baseTypes || [],
        variantsBases: productResult.baseTypes || [],
        basesSettings: productResult.bases_settings,
        selectedBase,
        params: normalizeParams(productResult.params, this.props.appLang),
        productLoading: false,
        variantsLoading: false,
        documentation: documentationResult.documentation || [],
        videos: videosResult.multimedia,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchProduct(id) {
    try {
      const product = await API2.getB2BCatalogProductAction(id);

      this.setState({
        product,
        variants: this.normalizeVariants(product.variants || []),
        allBases: product.baseTypes || [],
        variantsBases: product.baseTypes || [],
        selectedBase:
          product.baseTypes && product.baseTypes[0] && product.baseTypes[0],
        params: normalizeParams(product.params, this.props.appLang),
        productLoading: false,
        variantsLoading: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

  normalizeInspiration(inspirations, productId) {
    const {
      user: { firm },
    } = this.props;

    return inspirations.map(i => {
      const trans = i.trans.find(t => t.lang === firm) || {
        name: i.name,
        description: i.description,
        description_short: i.description_short,
        meta_description: i.meta_description,
        meta_title: i.meta_title,
      };

      const { shades } = i.products.find(p => p._id === productId);

      return {
        _id: i._id,
        titleImage:
          i.images &&
          (i.images.find(a => a.title_image) || i.images[0]).fullPath,
        images: i.images,
        shades,
        ...trans,
      };
    });
  }

  normalizeReferences(references, productId) {
    const {
      user: { firm },
    } = this.props;

    return references.map(r => {
      const trans = r.trans.find(t => t.lang === firm) || {
        name: r.name,
        description: r.description,
        description_short: r.description_short,
        meta_description: r.meta_description,
        meta_title: r.meta_title,
      };

      const { shades } = r.products.find(p => p._id === productId);

      return {
        _id: r._id,
        images: r.images || [],
        city: r.city || '',
        country: r.country || '',
        year: r.year || '',
        titleImage:
          r.images &&
          (r.images.find(i => i.title_image) || r.images[0]).fullPath,
        shades,
        products: r.products.filter(p => p.published),
        ...trans,
      };
    });
  }

  normalizeVariants(variants) {
    return variants
      .map(v => {
        const np = normalizeParams(v.variantParams);
        return Object.assign(
          v,
          {
            normalizedParams:
              np && np[0] && np[0].params
                ? np[0].params.filter(p => p.label !== 'Odtieň')
                : [],
          },
          Object.fromEntries(
            v.variantParams.map(item => [item.system_name, item.label]),
          ),
        );
      })
      .sort((a, b) => {
        if (a.volume > b.volume) {
          return 1;
        }

        if (a.volume < b.volume) {
          return -1;
        }

        return 0;
      });
  }

  removeSelectedShade() {
    this.fetchData(getIdFromProps(this.props));

    this.setState({
      selectedColorCode: '',
      selectedColorForSelect: null,
      selectedColor: undefined,
    });
  }

  fetchShades(query, productId) {
    const { selectedColorCard } = this.state;

    if (!productId) {
      return [];
    }
    try {
      const params = { q: query, limit: 200 };

      if (selectedColorCard && selectedColorCard.value) {
        params.colorcardId = selectedColorCard.value;
      }
      return API2.getB2BCatalogProductShadesAction(productId, params).then(
        res => {
          return {
            options: res.shades.map(item => ({
              value: item.color_code,
              color: item,
              label: `${item.color_base_name || item.color_name}`,
            })),
          };
        },
      );
    } catch (e) {
      return [];
    }
  }

  async searchColor(shade) {
    const { allBases } = this.state;
    if (!shade) {
      this.setState(
        {
          variantsBases: allBases,
          selectedColorCode: '',
          variantsLoading: true,
          selectedColor: undefined,
        },
        () => this.fetchProduct(getIdFromProps(this.props), true),
      );
      return;
    }

    this.setState(
      {
        colorNotFound: 0,
        colorCardId: shade.color.colorcard_id,
        selectedColor: shade.color.color,
        selectedColorCode: shade.color.color_base_name || shade.color_name,
      },
      () =>
        this.fetchPrices(
          shade.color.color_code,
          shade.color.colorcard_id,
          undefined,
          shade.color.color,
        ),
    );
  }

  handleKeyDown(e) {
    const { selectedColorCode } = this.state;
    if (e.key === 'Enter') {
      this.searchColor(selectedColorCode);
    }
  }

  openAddVariantToCard(id, isWh010Sale) {
    this.setState({
      variantToAddId: {
        id,
        isWh010Sale,
      },
    });
  }

  openAddThinnerToCard(id, isWh010Sale) {
    this.setState({
      thinnerToAddId: { id, isWh010Sale },
    });
  }

  addColoredVariantClicked(id, isWh010Sale) {
    this.setState({
      variantToAddId: { id, isWh010Sale },
    });
  }

  async fetchPrices(colorCode, colorCardId, base = undefined, color) {
    const { product, defaultVariants, allBases } = this.state;
    this.setState({
      variantsLoading: true,
    });

    if (!colorCode || !colorCardId) {
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    try {
      const colorcard = await API2.getB2BColorcardAction(colorCardId);

      const result = await API2.getB2BCatalogProductPricesAction(product._id, {
        base,
        shadeId: colorCode,
        colorCardId,
        toningSystemId: colorcard.system_id,
        applyDiscounts: true,
        customerId: this.props.user && this.props.user.customer_id,
      });

      const newVariants = [];

      result.prices.forEach(p => {
        const variant = defaultVariants.find(v => v._id === p._id);

        if (p.price && p.price_wd && p.price_wd_vat && p.price_vat && variant) {
          newVariants.push(
            Object.assign(variant, {
              price_for_toning: p.price.amount - p.default_price.amount,
              price_for_toning_vat:
                p.price.amount -
                p.default_price.amount +
                p.price_vat.amount -
                p.price.amount,
              price: p.price,
              price_wd: p.price_wd,
              price_wd_vat: p.price_wd_vat,
              price_vat: p.price_vat,
              tintingRisk: p.tintingRisk,
            }),
          );
        } else if (variant) {
          newVariants.push(variant);
        }
      });
      const goodBases = result.bases.filter(b => allBases.indexOf(b) > -1);

      this.setState({
        colorCardId,
        toningSystemId: colorcard.system_id,
        variantsLoading: false,
        selectedBase: goodBases[0],
        variantsBases: goodBases,
        selectedColorCode: colorCode,
        selectedColor: color,
        showColorCards: false,
        variants: newVariants,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async downloadFile(id) {
    return API2.getB2BDocumentationDownloadAction(id);
  }

  async downloadFileWithId(downloadId) {
    window.location.href = downloadId;

    this.setState({
      downloadId: undefined,
    });
  }

  processDataFromToning(data) {
    const { variants, allBases } = this.state;

    const newVariants = [];

    data.prices.forEach(p => {
      const variant = variants.find(v => v._id === p._id);

      if (variant) {
        newVariants.push(
          Object.assign(variant, {
            price_for_toning: p.price.amount - p.default_price.amount,
            price: p.price,
            price_wd: p.price_wd,
            price_wd_vat: p.price_wd_vat,
            price_vat: p.price_vat,
          }),
        );
      }
    });

    const goodBases = data.bases.filter(b => allBases.indexOf(b) > -1);

    this.setState({
      selectedBase: goodBases[0],
      variantsBases: goodBases,
      colorCardId: data.selectedColorCardId,
      toningSystemId: data.selectedToningSystem,
      selectedColorCode: data.selectedColorId,
      selectedColor: data.color.color,
      selectedColorForSelect: {
        label: data.color.color_base_name,
        value: data.color.color_code,
      },
      showColorCards: false,
      variants: newVariants,
    });
  }

  RGBData(selectedColor, baseSetting) {
    if (selectedColor) {
      return selectedColor;
    }

    if (!baseSetting || !baseSetting.color) {
      return {};
    }

    const color = baseSetting.color.label;

    if (color === 'Biela') {
      return {
        R: 255,
        G: 255,
        B: 255,
      };
    }

    if (color === 'Číra') {
      return {
        R: 252,
        G: 252,
        B: 255,
      };
    }

    return {};
  }

  sortByColorNumber(a, b, productId) {
    // zatial to je iba specialne triedenie pre produkt SPRAYPAINT MASTON ONE - 5d836750f83cb84e16685f08

    if (productId === '5d836750f83cb84e16685f08') {
      if (a.finished_shade && b.finished_shade) {
        const numA = a.finished_shade.match(/\d+/)
          ? parseInt(a.finished_shade.match(/\d+/)[0], 10)
          : 0;
        const numB = b.finished_shade.match(/\d+/)
          ? parseInt(b.finished_shade.match(/\d+/)[0], 10)
          : 0;

        // Compare numbers
        return numA >= numB ? 1 : -1;
      }
    }

    return 0;
  }

  renderColorLabel(finishedShade) {
    if (finishedShade) {
      if (finishedShade.image_path) {
        return (
          <TextureWrapper
            textColor={getRGBColorByBackground(finishedShade.color)}
            shadowColor={getRGBShadeByBackground(finishedShade.color)}
            color={formatColorToRGB(finishedShade.color)}
            backgroundImage={`${baseURL}/images/500x0/${
              finishedShade.image_path
            }`}
          >
            {finishedShade.color_code}
          </TextureWrapper>
        );
      }
      return (
        <TextureWrapper
          textColor={getRGBColorByBackground(finishedShade.color)}
          shadowColor={getRGBShadeByBackground(finishedShade.color)}
          color={formatColorToRGB(finishedShade.color)}
        >
          {finishedShade.color_code}
        </TextureWrapper>
      );
    }
    return <TextureWrapper>-</TextureWrapper>;
  }

  render() {
    const {
      product,
      variants,
      colorNotFound,
      selectedImage,
      showColorCards,
      selectedColorCode,
      selectedColor,
      selectedVariantIndex,
      productLoading,
      variantsLoading,
      coloredVariantToAddId,
      selectedBase,
      error,
      showProductAddedPopup,
      showComplementaryAdded,
      variantToAddId,
      thinnerToAddId,
      colorCardId,
      downloadId,
      toningSystemId,
      variantsBases,
      showPriceWithHardener,
      selectedColorForSelect,
      params,
      inspirations,
      references,
      paintSystems,
      documentation,
      videos,
      basesSettings,
      typesForTinting,
      paramsHeaders,
    } = this.state;

    if (productLoading) {
      return (
        <LoaderWrapper>
          <Loader size="xl" color="#70af00" />
        </LoaderWrapper>
      );
    }

    return (
      <React.Fragment>
        <Space />

        <AddToCartWidget
          history={this.props.history}
          callback={() => {
            this.setState({
              variantToAddId: null,
              thinnerToAddId: null,
              showProductAddedPopup: true,
            });
          }}
          closeCallBack={() =>
            this.setState({
              variantToAddId: null,
              thinnerToAddId: null,
            })
          }
          product={
            normalizeVariants(variants).find(
              p =>
                variantToAddId &&
                p._id === variantToAddId.id &&
                p.is_wh010_sale === variantToAddId.isWh010Sale,
            ) ||
            (product.thinners &&
              product.thinners.find(p => p._id === thinnerToAddId))
          }
          colorCode={selectedColorCode}
          toningSystemId={toningSystemId}
          colorCardId={colorCardId}
          catalogProductParams={product.params}
        />

        <MainWrapper>
          <AlertPopup
            alignUnderHeader
            display={showComplementaryAdded}
            text={__('Produkt bol pridaný do objednávky')}
            success
            onClose={() =>
              this.setState({
                showComplementaryAdded: false,
              })
            }
            onSubmit={() =>
              this.setState({
                showComplementaryAdded: false,
              })
            }
          />

          <PopUpWrapper
            display={showColorCards}
            message={__('Tónovanie produktu')}
            onClose={() =>
              this.setState({
                showColorCards: false,
              })
            }
            onEscClose={() =>
              this.setState({
                showColorCards: false,
              })
            }
          >
            <ToningWrapper height={window.innerHeight - 100}>
              <Toning
                location={this.props.location}
                history={this.props.history}
                confirmButtonTitle={__('Vložiť do objednávky')}
                includeSteps={[2, 3]}
                inputProduct={Object.assign(product, { variants })}
                reload={showColorCards}
                outputCallback={input => this.processDataFromToning(input)}
                customerId={this.props.user && this.props.user.customer_id}
                applyDiscount
              />
            </ToningWrapper>
          </PopUpWrapper>

          <AlertPopup
            alignUnderHeader
            display={downloadId}
            style
            onClose={() =>
              this.setState({
                downloadId: undefined,
              })
            }
            scrollContent
            alert
            text={__(`Prajete si uložiť súbor`)}
            onSubmit={() => this.downloadFileWithId(downloadId)}
            onDismiss={() =>
              this.setState({
                downloadId: undefined,
              })
            }
          />

          <AlertPopup
            alignUnderHeader
            display={colorNotFound === 1}
            style
            onClose={() =>
              this.setState({
                colorNotFound: 2,
              })
            }
            scrollContent
            alert
            text={__(
              `Vami zadaný kód odtieňa ${
                selectedColorCode.color_code
              } sa vo vzorkovníkoch produktu nenašiel. Chcete ho vyhľadať ručne?`,
            )}
            onSubmit={() =>
              this.setState({
                colorNotFound: 2,
                showColorCards: true,
              })
            }
            onDismiss={() =>
              this.setState({
                colorNotFound: 2,
              })
            }
          />
          <InsideWrapper>
            <ErrorMessage display={error} text={error} timeToShow={5} />
            <ErrorMessage
              display={showProductAddedPopup}
              success
              timeToShow={5}
              text={__('Produkt bol pridaný do objednávky')}
            />
            <TopPart>
              <GalleryWrapper>
                <Gallery
                  images={product.images || []}
                  selectedImageIndex={selectedVariantIndex}
                  selectedImage={selectedImage}
                  showMorePhotos={false}
                  onImageSelect={name =>
                    this.setState({
                      selectedImage: name,
                    })
                  }
                />
              </GalleryWrapper>
              <BaseInfoWrapper>
                <Title>{product.name}</Title>
                <ShortDesc>
                  {catalogDescTranslate(
                    this.props.appLang,
                    product.shortDescriptionTranslations,
                    product.shortDescription,
                  )}
                </ShortDesc>
                <Line />
                <InfoWrapper>
                  <HalfInfoWrapper>
                    <Row
                      style={{
                        marginBottom: rem(16),
                      }}
                    >
                      <StyledLabel style={{ marginRight: rem(8) }}>
                        {__('Výrobca:')}
                      </StyledLabel>
                      <Text>{product.brand}</Text>
                    </Row>

                    {product.color_cards && product.color_cards.length > 0 && (
                      <React.Fragment>
                        <Row style={{ marginBottom: rem(16) }}>
                          <StyledLabel>{__('Odtieň:')}</StyledLabel>
                          <SelectWrapper>
                            <ColorCodeInput
                              placeholder={__('Poznám kód odtieňa')}
                              value={selectedColorForSelect}
                              loadOptions={query =>
                                this.fetchShades(query, product._id)
                              }
                              handleOnChange={e => {
                                this.setState(
                                  {
                                    selectedColorForSelect: e,
                                  },
                                  () => this.searchColor(e),
                                );
                              }}
                            />
                          </SelectWrapper>

                          <Label style={{ marginLeft: rem(12) }}>
                            {__('alebo')}
                          </Label>
                          <ToningButtonWrapper
                            onClick={() =>
                              this.setState({
                                showColorCards: true,
                              })
                            }
                          >
                            <Icon name="painting_roller" color="#70af00" />
                            <div style={{ marginLeft: rem(8) }}>
                              {__('Odtieň')}
                            </div>
                          </ToningButtonWrapper>
                        </Row>
                      </React.Fragment>
                    )}

                    {typesForTinting.includes(product.type) &&
                      variantsBases.length > 0 && (
                        <Row style={{ marginTop: rem(10) }}>
                          <StyledLabel style={{ width: rem(60) }}>
                            {__('Báza:')}
                          </StyledLabel>
                          <StyledSelect
                            name={__('Báza')}
                            size="xs"
                            small
                            onChange={e => {
                              this.setState({
                                selectedBase: e.target.value,
                              });
                            }}
                          >
                            {variantsBases && variantsBases.length > 0 ? (
                              variantsBases.map(base => {
                                return (
                                  <option
                                    value={base}
                                    selected={selectedBase === base}
                                  >
                                    {base}
                                  </option>
                                );
                              })
                            ) : (
                              <option selected disabled>
                                -
                              </option>
                            )}
                          </StyledSelect>
                        </Row>
                      )}
                  </HalfInfoWrapper>
                  <Space />
                  <HalfInfoWrapper>
                    {typesForTinting.includes(product.type) &&
                      (selectedColor ||
                        (basesSettings.find(b => b.name === selectedBase) &&
                          basesSettings.find(b => b.name === selectedBase)
                            .color)) && (
                        <ColorHolder
                          color={formatColorToRGB(
                            this.RGBData(
                              selectedColor,
                              basesSettings.find(
                                b => b.name === selectedBase,
                              ) &&
                                basesSettings.find(
                                  b => b.name === selectedBase,
                                ),
                            ),
                          )}
                        >
                          {selectedColorCode ||
                            (basesSettings.find(b => b.name === selectedBase) &&
                              basesSettings.find(
                                b => b.name === selectedBase,
                              ) &&
                              basesSettings.find(b => b.name === selectedBase)
                                .color &&
                              basesSettings.find(b => b.name === selectedBase)
                                .color.label)}
                          {selectedColorCode && (
                            <ColorShadeCloser
                              onClick={() => this.removeSelectedShade()}
                            >
                              <Icon name="close" color="#e2e0e0" />
                            </ColorShadeCloser>
                          )}
                        </ColorHolder>
                      )}
                  </HalfInfoWrapper>
                </InfoWrapper>
                <Space />

                <ProductsWrapper>
                  <ProductRow>
                    {product.hasFinisedShade ? (
                      <ProductCellHeader style={{ width: rem(150) }}>
                        <Label style={{ fontSize: rem(12) }}>
                          {__('Odtieň')}
                        </Label>
                      </ProductCellHeader>
                    ) : (
                      <ProductCellHeader style={{ width: rem(150) }}>
                        {__('Názov')}
                      </ProductCellHeader>
                    )}

                    {paramsHeaders.map(np => (
                      <ProductCellHeader>
                        <Label style={{ fontSize: rem(12) }}>{np.label}</Label>
                        <UnderLabeL>{__('')}</UnderLabeL>
                      </ProductCellHeader>
                    ))}

                    {/* {typesForTinting.includes(product.type) &&
                      variants.find(v =>
                        v.variantParams.find(
                          vp => vp.system_name === 'filling',
                        ),
                      ) && (
                        <ProductCellHeader>
                          <Label>{__('Plnenie')}</Label>
                        </ProductCellHeader>
                      )}
                    {typesForTinting.includes(product.type) &&
                      variants.find(v =>
                        v.variantParams.find(
                          vp => vp.system_name === 'package',
                        ),
                      ) && (
                        <ProductCellHeader>
                          <Label>{__('Balenie')}</Label>
                        </ProductCellHeader>
                      )} */}

                    {/* {product.variants.find(
                      v => v.key_param && v.key_param.system_name !== 'shade',
                    ) &&
                      !typesForTinting.includes(product.type) && (
                        <ProductCellHeader>
                          <Label>
                            {product.variants.find(v => v.key_param)
                              ? product.variants.find(v => v.key_param)
                                  .key_param.name
                              : '-'}
                          </Label>
                        </ProductCellHeader>
                      )} */}

                    <ProductCellHeaderDPH>
                      <Label style={{ fontSize: rem(12) }}>
                        {__('Doporučená cena')}
                      </Label>
                      <UnderLabeL>{__('bez DPH')}</UnderLabeL>
                    </ProductCellHeaderDPH>
                    <ProductCellHeaderDPH>
                      <Label style={{ fontSize: rem(12) }}>
                        {__('Doporučená cena')}
                      </Label>
                      <UnderLabeL>{__('s DPH')}</UnderLabeL>
                    </ProductCellHeaderDPH>
                    <ProductCellHeader style={{ minWidth: rem(100) }} />
                  </ProductRow>
                  {variantsLoading && (
                    <CustomLoaderWrapper>
                      <Loader size="l" />
                    </CustomLoaderWrapper>
                  )}
                  <AnimatedFormMessageWrapper display={!variantsLoading}>
                    <ProductRowsWrapper>
                      {variants
                        .sort((a, b) =>
                          this.sortByColorNumber(
                            a,
                            b,
                            getIdFromProps(this.props),
                          ),
                        )
                        .filter(v => v.base === selectedBase || !v.base)
                        .map(v => (
                          <ProductRow>
                            {v.tintingRisk && (
                              <TooltipWrapper>
                                <InfoWithTooltip color="red">
                                  {`${__(
                                    'Niektorý z pigmentov tónovania obsahuje pigment s objemom menším ako',
                                  )} ${v.tintingRiskValue || 0.15}ml. ${__(
                                    'Môže dôjsť k odchýlke výsledného odtieňu',
                                  )}.`}
                                </InfoWithTooltip>
                              </TooltipWrapper>
                            )}
                            {/* {typesForTinting.includes(product.type) &&
                              v.variantParams &&
                              v.variantParams.find(
                                vp => vp.system_name === 'filling',
                              ) && (
                                <ProductCell>
                                  {
                                    normalizeParam(
                                      v.variantParams.find(
                                        vp => vp.system_name === 'filling',
                                      ),
                                    ).value
                                  }
                                </ProductCell>
                              )} */}

                            {product.hasFinisedShade ? (
                              this.renderColorLabel(v.finished_shade_detail)
                            ) : (
                              <ProductCell>
                                {v.name}
                                {v.is_sale && (
                                  <SaleLabel title={v.sale_note}>
                                    {__('%')}
                                  </SaleLabel>
                                )}
                                {/* {v.sale_note && v.sale_note.length > 0 && (
                                  <SaleNote>{v.sale_note} </SaleNote>
                                )} */}
                              </ProductCell>
                            )}

                            {paramsHeaders.map(ph => {
                              const value = v.normalizedParams.find(
                                np => np.label === ph.label,
                              );

                              return (
                                <ProductCell>
                                  {value ? value.value : '-'}
                                </ProductCell>
                              );
                            })}

                            {/* {typesForTinting.includes(product.type) &&
                              v.variantParams &&
                              v.variantParams.find(
                                vp => vp.system_name === 'package',
                              ) && (
                                <ProductCell>
                                  {
                                    normalizeParam(
                                      v.variantParams.find(
                                        vp => vp.system_name === 'package',
                                      ),
                                    ).value
                                  }
                                </ProductCell>
                              )} */}
                            {/* {!typesForTinting.includes(product.type) && ( */}
                            {/* {v.key_param && (
                              <ProductCell>
                                {v.key_param &&
                                  normalizeParam(v.key_param).value}
                              </ProductCell>
                            )} */}
                            {/* )} */}
                            <ProductCell>
                              {formatPrice(
                                showPriceWithHardener &&
                                  v.price_with_hardener_wd
                                  ? {
                                      amount:
                                        v.price_for_hardener_wd.amount +
                                        v.price_wd.amount,

                                      currency:
                                        v.price_with_hardener_wd.currency,
                                    }
                                  : v.price_wd,
                              )}
                            </ProductCell>
                            <ProductCell>
                              {formatPrice(
                                showPriceWithHardener &&
                                  v.price_with_hardener_vat_wd
                                  ? {
                                      amount:
                                        v.price_for_hardener_wd_vat.amount +
                                        v.price_wd_vat.amount,

                                      currency:
                                        v.price_with_hardener_vat_wd.currency,
                                    }
                                  : v.price_wd_vat,
                              )}
                            </ProductCell>
                            <ProductCellIcon>
                              <AddToCardWrapper
                                onClick={() => {
                                  this.addColoredVariantClicked(
                                    v._id,
                                    v.is_wh010_sale,
                                  );
                                }}
                              >
                                {coloredVariantToAddId &&
                                coloredVariantToAddId.id === v._id ? (
                                  <Loader />
                                ) : (
                                  <Icon name="cart_add" color="#70af00" />
                                )}
                              </AddToCardWrapper>
                            </ProductCellIcon>
                          </ProductRow>
                        ))}
                    </ProductRowsWrapper>
                  </AnimatedFormMessageWrapper>
                  {variants.find(
                    v =>
                      v.complementarsProducts && v.complementarsProducts.length,
                  ) && (
                    <ProductRow>
                      <CheckboxWrapper>
                        <CatalogCheckbox
                          checked={showPriceWithHardener}
                          onChange={() =>
                            this.setState({
                              showPriceWithHardener: !showPriceWithHardener,
                            })
                          }
                        />
                        <Label>
                          {__('Zobraziť cenu a objem vrátane tužidla')}
                        </Label>
                      </CheckboxWrapper>
                    </ProductRow>
                  )}
                </ProductsWrapper>
              </BaseInfoWrapper>
            </TopPart>
            <Space />
            <Space />
            <Space />
            <Tabs>
              <TabList>
                <Tab>{__('Popis')}</Tab>
                <Tab>{__('Varianty')}</Tab>
                {documentation.length > 0 && <Tab>{__('Dokumentácia')}</Tab>}
                {paintSystems.length > 0 && <Tab>{__('Náterové systémy')}</Tab>}
                {inspirations.length > 0 && <Tab>{__('Inšpirácie')}</Tab>}
                {videos.length > 0 && <Tab>{__('Videá')}</Tab>}
                {references.length > 0 && <Tab>{__('Referencie')}</Tab>}
              </TabList>
              <TabPanel>
                <Description
                  description={catalogDescTranslate(
                    this.props.appLang,
                    product.descriptionTranslations,
                    product.description,
                  )}
                  params={params}
                />
              </TabPanel>
              <TabPanel>
                <VariantsWrapper>
                  <Variants
                    role={this.props.user.role}
                    data={variants}
                    settings={this.props.settings}
                    loading={variantsLoading}
                    // cartItemsIds={cartItemsIds}
                    // cartItems={cartItems}
                    variantLoadingId={variantToAddId}
                    selectedVariantIndex={selectedVariantIndex}
                    addToCart={(variantId, isWh010Sale) =>
                      this.openAddVariantToCard(variantId, isWh010Sale)
                    }
                    onVariantSelect={index => {
                      this.setState({
                        selectedVariantIndex: index,
                        selectedImage: normalizeVariants(variants)[index].image,
                      });
                    }}
                  />
                </VariantsWrapper>

                {product.thinners && product.thinners.length > 0 && (
                  <React.Fragment>
                    <Title style={{ marginTop: rem(16) }}>
                      {__('Riedidlá:')}
                    </Title>
                    <Line style={{ margin: 0 }} />
                    <VariantsWrapper>
                      <Variants
                        settings={this.props.settings}
                        role={this.props.user.role}
                        data={product.thinners}
                        // cartItemsIds={cartItemsIds}
                        // cartItems={cartItems}
                        variantLoadingId={thinnerToAddId}
                        addToCart={thinnerId =>
                          this.openAddThinnerToCard(thinnerId)
                        }
                      />
                    </VariantsWrapper>
                  </React.Fragment>
                )}
              </TabPanel>
              <TabPanel>
                {documentation.length > 0 && (
                  <Documentation
                    files={documentation}
                    downloadFile={id => {
                      return this.downloadFile(id);
                    }}
                    history={this.props.history}
                  />
                )}
              </TabPanel>
              {paintSystems.length > 0 && (
                <TabPanel>
                  <PaintSystems
                    productId={getIdFromProps(this.props)}
                    history={this.props.history}
                    location={this.props.location}
                  />
                </TabPanel>
              )}
              {inspirations.length > 0 && (
                <TabPanel>
                  <Inspirations
                    inspirations={inspirations}
                    onShadeSelect={s =>
                      this.fetchPrices(
                        s.color_code,
                        s.colorcard_id,
                        undefined,
                        s.color,
                      )
                    }
                  />
                </TabPanel>
              )}
              {videos.length > 0 && (
                <TabPanel>
                  <Videos
                    productId={getIdFromProps(this.props)}
                    history={this.props.history}
                    location={this.props.location}
                  />
                </TabPanel>
              )}
              {references.length > 0 && (
                <TabPanel>
                  <References
                    references={references}
                    onShadeSelect={s =>
                      this.fetchPrices(
                        s.color_code,
                        s.colorcard_id,
                        undefined,
                        s.color,
                      )
                    }
                  />
                </TabPanel>
              )}
            </Tabs>
          </InsideWrapper>
        </MainWrapper>
      </React.Fragment>
    );
  }
}

CatalogProductDetail.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  user: PropTypes.shape({
    role: PropTypes.string,
    firm: PropTypes.string,
  }).isRequired,
  settings: PropTypes.shape({}).isRequired,
  firm: PropTypes.string.isRequired,
  location: PropTypes.shape({}).isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(CatalogProductDetail);



// WEBPACK FOOTER //
// ./src/Containers/Buy/Catalog/Detail/index.jsx